import * as React from 'react'
import { ReactElement } from 'react'
import { Route, Switch } from 'react-router'
import InvoiceApprovalOverview from './InvoiceApproval/InvoiceApprovalOverview'
import ViewInvoiceApproval from './InvoiceApproval/ViewInvoiceApproval'
import EditTime from './Time/EditTime'

export default function InvoiceApprovals(props): ReactElement {
    const url: string = props.location.pathname
    const baseUrl: string = /(\/invoice-approval\/[0-9a-z\-]+)/g.exec(url)?.filter(Boolean)[1]
    const approvalId: string = /\/invoice-approval\/([0-9a-z\-]+)/g.exec(url)?.filter(Boolean)[1]

    return (
        <Switch>
            <Route exact path="/invoice-approval" component={InvoiceApprovalOverview} />
            <Route path="/invoice-approval/add" component={ViewInvoiceApproval} />
            {approvalId && (
                <Route path={`/invoice-approval/:approvalId/time/:id/edit`} component={EditTime}>
                    <EditTime returnUrl={baseUrl} />
                </Route>
            )}
            <Route exact path="/invoice-approval/:id" component={ViewInvoiceApproval} />
        </Switch>
    )
}
